<!-- Home：2020/3/9 Vue: ^2.5.2 YuAng-->

<template>
  <div class="its-home">
    <banner :banners="banners" :height="height"></banner>
    <structure></structure>
    <system-introduce></system-introduce>
    <advantage></advantage>
    <honers></honers>
    <!--合作方式-->
    <cooperate></cooperate>
     <!--联系方式、申请试用-->
    <connect></connect>
  </div>
</template>

<script>
import Banner from './components/Banner'
import Cooperate from './components/Cooperate'
import Structure from './components/Structure'
import SystemIntroduce from './components/SystemIntroduce'
import Advantage from './components/Advantage'
import Honers from './components/Honers'
import Connect from '../intro/components/edition/Connect'
export default {
  name: 'Home',
  components: { Banner, Cooperate, SystemIntroduce, Advantage, Honers, Connect, Structure },
  data () {
    return {
      headerFixed: false,
      height: '774px',
      banners: [
        {
          key: 1,
          mainTitle: '省时省力&nbsp;&nbsp;因为懂你',
          subTitle: '好内容+好平台 更懂您的智慧教学',
          desc: '学科网e课堂基于学科网精品内容资源优势，融合大数据、<br>AI等技术打造而成，旨在辅助教师精准教学，助力区域、<br>学校智慧化管理，帮助家长实时获取孩子在校动态，构建<br>三位一体的智慧教学模式。',
          link: 'Introduction',
          url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-09.mp4',
          playCover: '@/assets/images/home/video_cover.png',
          coverType: 'banner'
        }
      ],
      platform: {
        title: '学科网e课堂云平台',
        server: [
          {
            icon: 'server',
            title: '微云服务器'
          },
          {
            icon: 'wifi',
            title: '阿里云toT路由器'
          }
        ],
        connect: [
          {
            icon: 'connect',
            title: '无线网络通讯'
          }
        ],
        teacher: [
          {
            icon: 'pad',
            title: '平板电脑'
          },
          {
            icon: 'block',
            title: '电子白板'
          }
        ],
        student: [
          {
            icon: 'pad',
            title: '平板终端'
          }
        ],
      },
      items: [
        '<div class="its-item">e课堂平台</div><div class="its-item">e课堂电脑客户端</div><div class="its-item">e课堂APP（教师）</div><div class="its-item">e课堂APP（学生）</div>',
        '<div class="its-item">e课堂平台</div><div class="its-item">e课堂电脑客户端</div><div class="its-item">e课堂APP（教师）</div><div class="its-item">e课堂APP（学生）</div>',
        '<div class="its-item">智慧黑板</div><div class="its-item">教师/学生平板</div><div class="its-item">无线AP</div><div class="its-item">平板充电柜</div>'
      ],
      titles: [
        '软件一体化',
        '软硬件一体化'
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: function () {
      this.$root.setHeaderBackground()
    }
  }
}
</script>

<style scoped>
.its-home {
  min-height: 50px;
  background: white;
}

.its-home >>> .its-background {
  background-color: #4390ff !important;
}


.its-teaching-steps {
  width: 100%;
  padding-bottom: 55px;
  background-image: linear-gradient(#ffffff, #f5f9ff, #f5f9ff);
}
.its-e-class-text {
  width: 1200px;
  padding: 0 116px;
  text-align: center;
  margin: 40px auto 0 auto;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(99, 103, 122, 1);
  line-height: 24px;
}
.marginTop-15 {
  margin-top: 15px;
}
.its-connect-us {
  width: 100%;
  height: 676px;
  margin-top: 90px;
  background: url(../../../../public/images/home_connect_us.png) no-repeat;
}
.its-connect-us >>> .its-title {
  margin-top: 0;
  padding-top: 90px;
}
.its-container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.its-e-class-bg {
  position: absolute;
}
.its-e-class-bg-1 {
  top: 0;
  left: -64px;
  opacity: 0.2;
}
.its-e-class-bg-2 {
  top: 454px;
  left: -210px;
  opacity: 0.6;
}
.its-e-class-bg-3 {
  top: 646px;
  left: 119px;
  opacity: 0.7;
}
.its-e-class-bg-4 {
  top: 1185px;
  left: -113px;
}
.its-e-class-bg-5 {
  top: 200px;
  right: -172px;
  opacity: 0.2;
}
.its-e-class-bg-6 {
  top: 411px;
  right: -333px;
  opacity: 0.6;
}
.its-e-class-bg-7 {
  top: 800px;
  right: -17px;
  opacity: 0.7;
}
.its-e-class-bg-8 {
  top: 1315px;
  right: -148px;
}
</style>
